// This controller runs every time citations are broadcasted
import { Controller } from "@hotwired/stimulus";
import { isInIframe } from "lib/utilities";
import { useDocumentListener } from "lib/event_helpers"
import * as Bootstrap from 'bootstrap';
import ahoy from "ahoy.js";

export default class extends Controller {
  static values = {
    keyword: Boolean
  }

  connect() {
    this.reveal();
  }

  reveal() {
    useDocumentListener(this, 'chat--broadcast:complete', (event) => {
      // Need to target both keyword and non-keyword citations
      const collapseEls = event.detail.content.element.querySelectorAll(".chat--citations");
      collapseEls.forEach(collapseEl => {
        if (collapseEl) {
          const bsCollapse = new Bootstrap.Collapse(collapseEl, { toggle: false });
          bsCollapse.show()
        }
      });
    });
  }

  log(event) {
    let source = isInIframe() ? "iframe" : "direct";
    let eventName = this.keywordValue ? "TopArticleLinkClick" : "CitationLinkClick";
    let linkText = event.target.innerText;
    let href = event.target.href;

    ahoy.track(eventName, {
      linkText: linkText,
      href: href,
      source: source,
      organization: this.application.dewey?.organization?.name,
      organization_id: this.application.dewey?.organization?.id,
      user_id: this.application.dewey?.user?.id
    });
  }
}
